import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "dropdown" ]

  connect() {
    $(this.dropdownTarget).chosen()
  }
}
